import routerConstants from '@/constants/routerConstants'

/** Các list vận hành có lọc kho vật lý trên toolbar. */
const VAN_HANH_LIST_PATHS = new Set<string>([
  routerConstants.vanHanh.list,
  routerConstants.vanHanh.xepNhat,
  routerConstants.vanHanh.kiemTra,
  routerConstants.vanHanh.dongGoi,
  routerConstants.vanHanh.dieuPhoi,
  routerConstants.vanHanh.giaoHang,
])

/**
 * Gắn `khoVatLyIds` = kho của chi nhánh đang đứng khi bấm menu Vận hành.
 * Reload URL không có param thì không tự thêm — chỉ khi điều hướng từ menu.
 */
export function withCurrentKhoVatLyQuery(to: string, khoVatLyId: number | null): string {
  if (khoVatLyId == null || khoVatLyId <= 0) return to
  const qIndex = to.indexOf('?')
  const path = qIndex >= 0 ? to.slice(0, qIndex) : to
  if (!VAN_HANH_LIST_PATHS.has(path)) return to
  const params = new URLSearchParams(qIndex >= 0 ? to.slice(qIndex + 1) : '')
  params.set('khoVatLyIds', String(khoVatLyId))
  const qs = params.toString()
  return qs ? `${path}?${qs}` : path
}
